import React from 'react'
import './styles.scss'
import ReactMarkdown from 'react-markdown'
const Equality = ({title, text, logos}) => {
    return (
        <section className="section section--equality">
            <div className="wrapper--text">
                <div className="equality">
                <h3 className="equality__title">{title}</h3>
                <p className="equality__text">{text}</p>
                <ul className="equality__logos">
                    {
                        logos.map((logo, index) => {
                            return (
                                <li key={index} className="equality__logo" dangerouslySetInnerHTML={{__html: logo.asset}}>
                                    
                                </li>
                            )
                        })
                    }
                </ul>
                </div>
            </div>
        </section>
    )
}

export default Equality